import React from 'react';
import './Footer.css';
import Github from '../../../assets/github.png';
import Instagram from '../../../assets/instagram.png';
import LinkedIn from '../../../assets/linkedin.png';
import Logo from '../../../assets/logoown.jpg';

const Footer = () => {
  return (
    <div className="Footer-container">
      <hr/>
      <div className="footer">
        <div className="social-links">
          <a href="https://github.com/your-github-username" target="_blank" rel="noopener noreferrer">
            <img src={Github} alt="GitHub"/>
          </a>
          <a href="https://instagram.com/your-instagram-username" target="_blank" rel="noopener noreferrer">
            <img src={Instagram} alt="Instagram"/>
          </a>
          <a href="https://www.linkedin.com/in/md-sufiyan-alam-1089bb286" target="_blank" rel="noopener noreferrer">
  <img src={LinkedIn} alt="LinkedIn" />
</a>

        </div>
        <div className="logo-f">
          <img src={Logo} alt="Logo"/>
        </div>
      </div>
      <div className="blur blur-f-1"></div>
      <div className="blur blur-f-2"></div>
    </div>
  );
}

export default Footer;
